module.exports = __webpack_public_path__ + "static/lemonade-envs-01673982139911a708c5cc74563fc222.png";